import { useSearch } from '@tanstack/react-router';

export function useList() {
    const list = useSearch({ from: '__root__', select: ({ list }) => list });

    return list;
}
